module.exports = __webpack_public_path__ + "img/fuki03_pc.cbf4667a.png";